(function () {
  'use strict';

  const $ = (selector, context = document) => context.querySelector(selector);
  const $$ = (selector, context = document) => Array.from(context.querySelectorAll(selector));
  const backdrop = $('[data-drawer-backdrop]');

  function ajaxUrl(url) {
    if (!url) return '';
    return url.endsWith('.js') || url.endsWith('.json') ? url : `${url}.js`;
  }

  function formatMoney(cents) {
    const value = Number(cents || 0) / 100;
    const format = window.themeSettings && window.themeSettings.moneyFormat ? window.themeSettings.moneyFormat : 'Rs. {{amount}}';
    return format
      .replace('{{amount}}', value.toFixed(2))
      .replace('{{amount_no_decimals}}', Math.round(value).toString())
      .replace('{{amount_with_comma_separator}}', value.toFixed(2).replace('.', ','));
  }

  function escapeHtml(value) {
    return String(value || '')
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;');
  }

  function setBodyLock(locked) {
    document.documentElement.classList.toggle('drawer-open', locked);
    document.body.style.overflow = locked ? 'hidden' : '';
  }

  function closeDrawers() {
    $$('[data-drawer].is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    $$('[aria-expanded="true"][data-drawer-open]').forEach((button) => button.setAttribute('aria-expanded', 'false'));
    if (backdrop) {
      backdrop.classList.remove('is-visible');
      window.setTimeout(() => {
        if (!$$('[data-drawer].is-open').length) backdrop.hidden = true;
      }, 260);
    }
    setBodyLock(false);
  }

  function openDrawer(name) {
    const drawer = $(`[data-drawer="${name}"]`);
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    $$(`[data-drawer-open="${name}"]`).forEach((button) => button.setAttribute('aria-expanded', 'true'));
    if (backdrop) {
      backdrop.hidden = false;
      requestAnimationFrame(() => backdrop.classList.add('is-visible'));
    }
    setBodyLock(true);

    if (name === 'search') {
      window.setTimeout(() => $('#SearchDrawerInput') && $('#SearchDrawerInput').focus(), 220);
    }
    if (name === 'cart') refreshCart();
  }

  function initDrawers() {
    $$('[data-drawer-open]').forEach((button) => {
      button.addEventListener('click', () => openDrawer(button.dataset.drawerOpen));
    });
    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-drawer-close]')) closeDrawers();
    });
    if (backdrop) backdrop.addEventListener('click', closeDrawers);
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') closeDrawers();
    });
  }

  function initHeader() {
    const header = $('[data-site-header]');
    if (!header) return;
    const update = () => header.classList.toggle('is-scrolled', window.scrollY > 8);
    update();
    window.addEventListener('scroll', update, { passive: true });
  }

  function initAnnouncement() {
    const bar = $('#AnnouncementBar');
    if (!bar) return;
    const close = $('.announcement-bar__close', bar);
    if (!close) return;
    if (sessionStorage.getItem('coraali_announcement_closed') === '1') {
      bar.hidden = true;
      return;
    }
    close.addEventListener('click', () => {
      sessionStorage.setItem('coraali_announcement_closed', '1');
      bar.hidden = true;
    });
  }

  async function fetchCart() {
    const response = await fetch(ajaxUrl(window.routes.cart_url), { headers: { Accept: 'application/json' } });
    if (!response.ok) throw new Error('Unable to load cart');
    return response.json();
  }

  function updateCartCount(count) {
    $$('[data-cart-count]').forEach((el) => {
      el.textContent = count;
      el.hidden = count === 0;
    });
  }

  function renderCartLine(item) {
    const image = item.image ? `<img src="${escapeHtml(item.image)}" alt="${escapeHtml(item.product_title)}" loading="lazy" width="86" height="86">` : '';
    const variant = item.variant_title && item.variant_title !== 'Default Title' ? `<p class="cart-line__variant">${escapeHtml(item.variant_title)}</p>` : '';
    return `
      <div class="cart-line" data-cart-line data-key="${escapeHtml(item.key)}">
        <a class="cart-line__image" href="${escapeHtml(item.url)}">${image}</a>
        <div class="cart-line__info">
          <a href="${escapeHtml(item.url)}" class="cart-line__title">${escapeHtml(item.product_title)}</a>
          ${variant}
          <div class="cart-line__meta">
            <div class="line-qty">
              <button type="button" data-cart-qty="minus" aria-label="Decrease quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-qty="plus" aria-label="Increase quantity">+</button>
            </div>
            <span class="cart-line__price">${formatMoney(item.final_line_price)}</span>
          </div>
          <button type="button" class="cart-line__remove" data-cart-remove>Remove</button>
        </div>
      </div>`;
  }

  function renderEmptyCart() {
    return `
      <div class="cart-empty">
        <svg viewBox="0 0 24 24" aria-hidden="true"><circle cx="9" cy="21" r="1"/><circle cx="20" cy="21" r="1"/><path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6"/></svg>
        <h3>Your cart is empty</h3>
        <p>Your beauty shelf is waiting. Add your favorites to begin.</p>
        <a href="${escapeHtml(window.routes.all_products_collection_url)}" class="button button--primary" data-drawer-close>Continue shopping</a>
      </div>`;
  }

  function updateGiftProgress(total) {
    const threshold = Number(window.themeSettings.freeGiftThreshold || 0);
    const percent = threshold ? Math.min(100, Math.round((total / threshold) * 100)) : 0;
    const message = $('[data-cart-gift-message]');
    const progress = $('[data-cart-progress]');
    if (progress) progress.style.width = `${percent}%`;
    if (message && threshold) {
      message.textContent = total >= threshold
        ? 'Free gift unlocked for this order'
        : `Add ${formatMoney(threshold - total)} more to unlock a free gift`;
    }
  }

  function renderCart(cart) {
    updateCartCount(cart.item_count);
    const items = $('[data-cart-items]');
    const footer = $('[data-cart-footer]');
    const total = $('[data-cart-total]');
    const subtitle = $('[data-cart-subtitle]');
    if (subtitle) subtitle.textContent = cart.item_count > 0 ? `${cart.item_count} item${cart.item_count === 1 ? '' : 's'}` : 'Your cart is empty';
    if (items) items.innerHTML = cart.item_count > 0 ? cart.items.map(renderCartLine).join('') : renderEmptyCart();
    if (footer) footer.hidden = cart.item_count === 0;
    if (total) total.textContent = formatMoney(cart.total_price);
    updateGiftProgress(cart.total_price);
  }

  async function refreshCart() {
    try {
      const cart = await fetchCart();
      renderCart(cart);
      return cart;
    } catch (error) {
      return null;
    }
  }

  async function changeCartItem(key, quantity) {
    const response = await fetch(ajaxUrl(window.routes.cart_change_url), {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    });
    if (!response.ok) throw new Error('Unable to update cart');
    const cart = await response.json();
    renderCart(cart);
    return cart;
  }

  async function addToCart(form, options = {}) {
    const formData = new FormData(form);
    const selectedExtras = $$('[data-fbt-checkbox]:checked', form);
    const button = form.querySelector('[type="submit"], [data-atc-button]');
    if (button) button.classList.add('is-loading');
    try {
      const request = { method: 'POST', headers: { Accept: 'application/json' }, body: formData };
      if (selectedExtras.length) {
        request.headers['Content-Type'] = 'application/json';
        request.body = JSON.stringify({
          items: [
            { id: Number(formData.get('id')), quantity: Number(formData.get('quantity') || 1) },
            ...selectedExtras.map((input) => ({ id: Number(input.value), quantity: 1 }))
          ]
        });
      }
      const response = await fetch(ajaxUrl(window.routes.cart_add_url), request);
      const data = await response.json();
      if (!response.ok || data.status) throw new Error(data.description || window.themeStrings.addError);
      await refreshCart();
      if (options.openCart === true) openDrawer('cart');
      return data;
    } catch (error) {
      window.alert(error.message || window.themeStrings.addError);
      return null;
    } finally {
      if (button) button.classList.remove('is-loading');
    }
  }

  function initCart() {
    const drawer = $('#CartDrawer');
    if (drawer) {
      drawer.addEventListener('click', async (event) => {
        const line = event.target.closest('[data-cart-line]');
        if (!line) return;
        const key = line.dataset.key;
        const qtyText = $('.line-qty span', line);
        const currentQty = Number(qtyText ? qtyText.textContent : 1);
        if (event.target.closest('[data-cart-remove]')) {
          await changeCartItem(key, 0);
        }
        if (event.target.closest('[data-cart-qty="minus"]')) {
          await changeCartItem(key, Math.max(0, currentQty - 1));
        }
        if (event.target.closest('[data-cart-qty="plus"]')) {
          await changeCartItem(key, currentQty + 1);
        }
      });
    }

    document.addEventListener('submit', (event) => {
      const form = event.target.closest('[data-product-form]');
      if (!form) return;
      event.preventDefault();
      addToCart(form);
    });
  }

  function initQuantity() {
    document.addEventListener('click', (event) => {
      const plus = event.target.closest('[data-quantity-plus]');
      const minus = event.target.closest('[data-quantity-minus]');
      if (!plus && !minus) return;
      const stepper = event.target.closest('.quantity-stepper');
      const input = stepper && $('input', stepper);
      if (!input) return;
      const next = Math.max(Number(input.min || 1), Number(input.value || 1) + (plus ? 1 : -1));
      input.value = next;
    });
  }

  function updateVariantState(picker, variant) {
    const section = picker.closest('[data-product-section]');
    if (!section || !variant) return;
    $$('[data-variant-id]', section).forEach((input) => { input.value = variant.id; });
    const price = $('[data-product-price]', section);
    if (price) {
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price;
      const discount = compare ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
      price.innerHTML = `<span class="price-current">${formatMoney(variant.price)}</span>${compare ? `<s class="price-compare">${formatMoney(variant.compare_at_price)}</s><span class="price-discount">${discount}% Off</span>` : ''}`;
    }
    const stickyPrice = $('[data-sticky-price]', section);
    if (stickyPrice) {
      const compare = variant.compare_at_price && variant.compare_at_price > variant.price;
      const discount = compare ? Math.round(((variant.compare_at_price - variant.price) / variant.compare_at_price) * 100) : 0;
      stickyPrice.innerHTML = `<strong>${formatMoney(variant.price)}</strong>${compare ? `<s>${formatMoney(variant.compare_at_price)}</s><em>${discount}% Off</em>` : ''}`;
    }
    $$('[data-atc-button], [data-buy-now], [data-sticky-add]', section).forEach((button) => {
      button.disabled = !variant.available;
      if (button.matches('[data-atc-button], [data-sticky-add]')) {
        button.textContent = variant.available ? 'Add to Cart' : 'Sold Out';
      }
    });
  }

  function initVariantPickers() {
    $$('[data-variant-picker]').forEach((picker) => {
      let variants = [];
      try {
        variants = JSON.parse(picker.dataset.productJson || '[]');
      } catch (error) {
        variants = [];
      }
      picker.addEventListener('click', (event) => {
        const option = event.target.closest('[data-option-value]');
        if (!option) return;
        const group = option.closest('[data-option-index]');
        if (!group) return;
        $$('[data-option-value]', group).forEach((button) => {
          button.classList.toggle('is-active', button === option);
          button.setAttribute('aria-pressed', button === option ? 'true' : 'false');
        });
        const label = $('[data-selected-option]', group);
        if (label) label.textContent = option.dataset.optionValue;
        const selected = $$('[data-option-index]', picker).map((fieldset) => {
          const active = $('.is-active[data-option-value]', fieldset);
          return active ? active.dataset.optionValue : '';
        });
        const match = variants.find((variant) => variant.options.every((value, index) => value === selected[index]));
        if (match) updateVariantState(picker, match);
      });
    });

    $$('[data-sticky-add]').forEach((button) => {
      button.addEventListener('click', () => {
        const section = button.closest('[data-product-section]');
        const form = section && $('[data-product-form]', section);
        if (form) addToCart(form);
      });
    });

    $$('[data-buy-now]').forEach((button) => {
      button.addEventListener('click', async () => {
        const form = button.closest('[data-product-section]') && $('[data-product-form]', button.closest('[data-product-section]'));
        if (!form) return;
        const added = await addToCart(form, { openCart: false });
        if (added) window.location.href = window.routes.checkout_url || '/checkout';
      });
    });
  }

  function initProductGallery() {
    $$('[data-product-gallery]').forEach((gallery) => {
      if (gallery.dataset.galleryInitialized === 'true') return;
      gallery.dataset.galleryInitialized = 'true';
      const main = $('[data-product-main-image]', gallery);
      if (!main) return;
      const mainFrame = $('.product-gallery__main', gallery);
      const thumbs = $$('[data-gallery-thumb]', gallery);
      let activeIndex = Math.max(0, thumbs.findIndex((thumb) => thumb.classList.contains('is-active')));
      let startX = 0;
      let startY = 0;
      let touchStartX = 0;
      let touchStartY = 0;

      const showImage = (index) => {
        if (!thumbs.length) return;
        activeIndex = (index + thumbs.length) % thumbs.length;
        thumbs.forEach((button, buttonIndex) => button.classList.toggle('is-active', buttonIndex === activeIndex));
        const activeThumb = thumbs[activeIndex];
        main.src = activeThumb.dataset.src;
        main.removeAttribute('srcset');
        activeThumb.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      };

      gallery.addEventListener('click', (event) => {
        const thumb = event.target.closest('[data-gallery-thumb]');
        if (!thumb) return;
        showImage(thumbs.indexOf(thumb));
      });

      if (mainFrame && thumbs.length > 1) {
        mainFrame.addEventListener('pointerdown', (event) => {
          if (!event.isPrimary || event.pointerType === 'touch') return;
          startX = event.clientX;
          startY = event.clientY;
        });
        mainFrame.addEventListener('pointerup', (event) => {
          if (!event.isPrimary || event.pointerType === 'touch') return;
          const distanceX = event.clientX - startX;
          const distanceY = event.clientY - startY;
          if (Math.abs(distanceX) < 38 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
          showImage(activeIndex + (distanceX < 0 ? 1 : -1));
        });
        mainFrame.addEventListener('touchstart', (event) => {
          const touch = event.changedTouches[0];
          touchStartX = touch.clientX;
          touchStartY = touch.clientY;
        }, { passive: true });
        mainFrame.addEventListener('touchend', (event) => {
          const touch = event.changedTouches[0];
          const distanceX = touch.clientX - touchStartX;
          const distanceY = touch.clientY - touchStartY;
          if (Math.abs(distanceX) < 32 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
          showImage(activeIndex + (distanceX < 0 ? 1 : -1));
        }, { passive: true });
      }
    });
  }

  function initProductZoom() {
    $$('[data-product-section]').forEach((section) => {
      const viewer = $('[data-product-zoom]', section);
      const openButton = $('[data-product-zoom-open]', section);
      if (!viewer || !openButton || viewer.dataset.zoomInitialized === 'true') return;
      viewer.dataset.zoomInitialized = 'true';

      const viewport = $('[data-product-zoom-viewport]', viewer);
      const slides = $$('[data-product-zoom-slide]', viewer);
      const dots = $$('[data-product-zoom-dot]', viewer);
      const galleryThumbs = $$('[data-gallery-thumb]', section);
      let current = 0;
      let zoom = 1;
      let pinchDistance = 0;
      let pinchZoom = 1;
      let lastTap = 0;
      let touchStartX = 0;
      let touchStartY = 0;

      const setZoom = (nextZoom) => {
        zoom = Math.min(4, Math.max(1, Math.round(nextZoom * 10) / 10));
        viewer.classList.toggle('is-zoomed', zoom > 1);
        slides.forEach((slide, index) => {
          const image = $('img', slide);
          image.style.width = index === current && zoom > 1 ? `${zoom * 100}%` : '';
        });
        if (zoom === 1) viewport.scrollTo({ top: 0, left: 0 });
      };
      const show = (index) => {
        current = (index + slides.length) % slides.length;
        setZoom(1);
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false'));
      };
      const open = () => {
        const selectedIndex = galleryThumbs.findIndex((thumb) => thumb.classList.contains('is-active'));
        show(selectedIndex >= 0 ? selectedIndex : 0);
        viewer.classList.add('is-open');
        viewer.setAttribute('aria-hidden', 'false');
        document.documentElement.classList.add('product-zoom-open');
        $('[data-product-zoom-close]', viewer)?.focus();
      };
      const close = () => {
        viewer.classList.remove('is-open');
        viewer.setAttribute('aria-hidden', 'true');
        document.documentElement.classList.remove('product-zoom-open');
        setZoom(1);
        openButton.focus();
      };
      const distance = (touches) => Math.hypot(touches[0].clientX - touches[1].clientX, touches[0].clientY - touches[1].clientY);

      openButton.addEventListener('click', open);
      $('[data-product-zoom-close]', viewer)?.addEventListener('click', close);
      $('[data-product-zoom-previous]', viewer)?.addEventListener('click', () => show(current - 1));
      $('[data-product-zoom-next]', viewer)?.addEventListener('click', () => show(current + 1));
      dots.forEach((dot) => dot.addEventListener('click', () => show(Number(dot.dataset.productZoomDot))));
      viewer.addEventListener('click', (event) => { if (event.target === viewer) close(); });
      viewer.addEventListener('wheel', (event) => {
        event.preventDefault();
        setZoom(zoom + (event.deltaY < 0 ? .25 : -.25));
      }, { passive: false });
      viewport.addEventListener('touchstart', (event) => {
        if (event.touches.length === 2) {
          pinchDistance = distance(event.touches);
          pinchZoom = zoom;
        } else if (event.touches.length === 1) {
          touchStartX = event.touches[0].clientX;
          touchStartY = event.touches[0].clientY;
        }
      }, { passive: true });
      viewport.addEventListener('touchmove', (event) => {
        if (event.touches.length !== 2 || !pinchDistance) return;
        event.preventDefault();
        setZoom(pinchZoom * (distance(event.touches) / pinchDistance));
      }, { passive: false });
      viewport.addEventListener('touchend', (event) => {
        if (event.touches.length < 2) pinchDistance = 0;
        if (event.changedTouches.length !== 1) return;
        const distanceX = event.changedTouches[0].clientX - touchStartX;
        const distanceY = event.changedTouches[0].clientY - touchStartY;
        if (zoom === 1 && Math.abs(distanceX) > 38 && Math.abs(distanceX) > Math.abs(distanceY)) {
          show(current + (distanceX < 0 ? 1 : -1));
          return;
        }
        const now = Date.now();
        if (now - lastTap < 300) setZoom(zoom > 1 ? 1 : 2);
        lastTap = now;
      }, { passive: true });
      document.addEventListener('keydown', (event) => {
        if (!viewer.classList.contains('is-open')) return;
        if (event.key === 'Escape') close();
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
        if (event.key === '+' || event.key === '=') setZoom(zoom + .5);
        if (event.key === '-') setZoom(zoom - .5);
      });
    });
  }

  function initStickyAtc() {
    $$('[data-product-section]').forEach((section) => {
      const sticky = $('[data-sticky-atc]', section);
      const actions = $('.product-actions', section);
      if (!sticky || !actions || sticky.dataset.visibilityReady === 'true') return;
      sticky.dataset.visibilityReady = 'true';
      const observer = new IntersectionObserver((entries) => {
        sticky.classList.toggle('is-visible', !entries[0].isIntersecting);
      }, { threshold: 0.01 });
      observer.observe(actions);
    });
  }

  function initProductShare() {
    $$('[data-product-share]').forEach((button) => {
      if (button.dataset.shareReady === 'true') return;
      button.dataset.shareReady = 'true';
      button.addEventListener('click', async () => {
        const title = button.dataset.shareTitle || document.title;
        const url = button.dataset.shareUrl || window.location.href;
        const status = $('[data-share-status]', button.parentElement);
        try {
          if (navigator.share) {
            await navigator.share({ title, url });
            return;
          }
          if (navigator.clipboard && window.isSecureContext) {
            await navigator.clipboard.writeText(url);
          } else {
            const input = document.createElement('textarea');
            input.value = url;
            input.setAttribute('readonly', '');
            input.style.position = 'fixed';
            input.style.opacity = '0';
            document.body.appendChild(input);
            input.select();
            document.execCommand('copy');
            input.remove();
          }
          button.classList.add('is-copied');
          if (status) status.textContent = 'Product link copied';
          window.setTimeout(() => {
            button.classList.remove('is-copied');
            if (status) status.textContent = '';
          }, 1800);
        } catch (error) {
          if (error.name !== 'AbortError' && status) status.textContent = 'Unable to share this product';
        }
      });
    });
  }

  function initSearch() {
    const input = $('[data-predictive-search-input]');
    const results = $('[data-predictive-results]');
    if (!input || !results) return;
    let timer;
    input.addEventListener('input', () => {
      window.clearTimeout(timer);
      const query = input.value.trim();
      if (query.length < 2) {
        results.innerHTML = '';
        return;
      }
      timer = window.setTimeout(async () => {
        try {
          const url = `${window.routes.predictive_search_url}.json?q=${encodeURIComponent(query)}&resources[type]=product&resources[limit]=4`;
          const response = await fetch(url, { headers: { Accept: 'application/json' } });
          const data = await response.json();
          const products = data.resources && data.resources.results ? data.resources.results.products : [];
          results.innerHTML = products.map((product) => `
            <a class="search-product" href="${escapeHtml(product.url)}">
              ${product.featured_image && product.featured_image.url ? `<img src="${escapeHtml(product.featured_image.url)}" alt="${escapeHtml(product.title)}" width="48" height="48">` : ''}
              <span>${escapeHtml(product.title)}</span>
            </a>
          `).join('');
        } catch (error) {
          results.innerHTML = '';
        }
      }, 220);
    });
  }

  function initHeroSliders(scope = document) {
    $$('[data-hero-slider]', scope).forEach((slider) => {
      if (slider.dataset.heroInitialized === 'true') return;
      slider.dataset.heroInitialized = 'true';
      const slides = $$('[data-hero-slide]', slider);
      const dots = $$('[data-hero-dot]', slider);
      if (slides.length < 2) return;

      let current = 0;
      let timer;
      let startX = 0;
      let startY = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let swiped = false;
      const reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const autoplay = slider.dataset.autoplay === 'true' && !reducedMotion;
      const interval = Math.max(3000, Number(slider.dataset.interval) || 5000);

      const show = (index) => {
        current = (index + slides.length) % slides.length;
        slides.forEach((slide, slideIndex) => {
          const active = slideIndex === current;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', active ? 'false' : 'true');
        });
        dots.forEach((dot, dotIndex) => dot.setAttribute('aria-current', dotIndex === current ? 'true' : 'false'));
      };
      const stop = () => window.clearInterval(timer);
      const start = () => {
        stop();
        if (autoplay && !document.hidden) timer = window.setInterval(() => show(current + 1), interval);
      };

      $('[data-hero-previous]', slider)?.addEventListener('click', () => { show(current - 1); start(); });
      $('[data-hero-next]', slider)?.addEventListener('click', () => { show(current + 1); start(); });
      dots.forEach((dot) => dot.addEventListener('click', () => { show(Number(dot.dataset.heroDot)); start(); }));
      slider.addEventListener('keydown', (event) => {
        if (event.key === 'ArrowLeft') show(current - 1);
        if (event.key === 'ArrowRight') show(current + 1);
      });
      slider.addEventListener('pointerdown', (event) => {
        if (!event.isPrimary || event.pointerType === 'touch') return;
        startX = event.clientX;
        startY = event.clientY;
        swiped = false;
      });
      slider.addEventListener('pointerup', (event) => {
        if (!event.isPrimary || event.pointerType === 'touch') return;
        const distanceX = event.clientX - startX;
        const distanceY = event.clientY - startY;
        if (Math.abs(distanceX) < 38 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        swiped = true;
        show(current + (distanceX < 0 ? 1 : -1));
        start();
      });
      slider.addEventListener('touchstart', (event) => {
        const touch = event.changedTouches[0];
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        swiped = false;
      }, { passive: true });
      slider.addEventListener('touchend', (event) => {
        const touch = event.changedTouches[0];
        const distanceX = touch.clientX - touchStartX;
        const distanceY = touch.clientY - touchStartY;
        if (Math.abs(distanceX) < 32 || Math.abs(distanceX) <= Math.abs(distanceY)) return;
        swiped = true;
        show(current + (distanceX < 0 ? 1 : -1));
        start();
      }, { passive: true });
      slider.addEventListener('pointercancel', () => { swiped = false; });
      slider.addEventListener('click', (event) => {
        if (!swiped) return;
        event.preventDefault();
        event.stopPropagation();
        swiped = false;
      }, true);
      slider.addEventListener('mouseenter', stop);
      slider.addEventListener('mouseleave', start);
      slider.addEventListener('focusin', stop);
      slider.addEventListener('focusout', start);
      document.addEventListener('visibilitychange', () => document.hidden ? stop() : start());
      start();
    });
  }

  function initCollectionFilters() {
    const facets = $('[data-collection-facets]');
    const openButton = $('[data-mobile-filters-open]');
    if (facets && openButton) {
      facets.setAttribute('aria-hidden', 'true');
      const close = () => {
        facets.classList.remove('is-open');
        facets.setAttribute('aria-hidden', 'true');
        openButton.setAttribute('aria-expanded', 'false');
        document.documentElement.classList.remove('drawer-open');
      };
      openButton.addEventListener('click', () => {
        facets.classList.add('is-open');
        facets.setAttribute('aria-hidden', 'false');
        openButton.setAttribute('aria-expanded', 'true');
        document.documentElement.classList.add('drawer-open');
      });
      $$('[data-mobile-filters-close]', facets).forEach((button) => button.addEventListener('click', close));
      document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && facets.classList.contains('is-open')) close();
      });
    }

    $$('[data-collection-sort]').forEach((select) => {
      select.addEventListener('change', () => {
        const url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });

    $$('[data-price-range]').forEach((range) => {
      const minRange = $('[data-price-min-range]', range);
      const maxRange = $('[data-price-max-range]', range);
      const minInput = $('[data-price-min-input]', range);
      const maxInput = $('[data-price-max-input]', range);
      const sliders = $('.price-range__sliders', range);
      const limit = Number(range.dataset.rangeMax) || 0;
      if (!minRange || !maxRange || !minInput || !maxInput || !sliders || !limit) return;

      const updateTrack = () => {
        sliders.style.setProperty('--range-min', `${(Number(minRange.value) / limit) * 100}%`);
        sliders.style.setProperty('--range-max', `${(Number(maxRange.value) / limit) * 100}%`);
      };
      const syncFromRanges = (source) => {
        if (source === minRange && Number(minRange.value) > Number(maxRange.value)) minRange.value = maxRange.value;
        if (source === maxRange && Number(maxRange.value) < Number(minRange.value)) maxRange.value = minRange.value;
        minInput.value = minRange.value;
        maxInput.value = maxRange.value;
        updateTrack();
      };
      const syncFromInputs = () => {
        const min = Math.max(0, Math.min(Number(minInput.value) || 0, limit));
        const max = Math.max(min, Math.min(Number(maxInput.value) || limit, limit));
        minInput.value = min;
        maxInput.value = max;
        minRange.value = min;
        maxRange.value = max;
        updateTrack();
      };
      minRange.addEventListener('input', () => syncFromRanges(minRange));
      maxRange.addEventListener('input', () => syncFromRanges(maxRange));
      minInput.addEventListener('change', syncFromInputs);
      maxInput.addEventListener('change', syncFromInputs);
      updateTrack();
    });
  }

  document.addEventListener('DOMContentLoaded', () => {
    initHeader();
    initAnnouncement();
    initDrawers();
    initCart();
    initQuantity();
    initVariantPickers();
    initProductGallery();
    initProductZoom();
    initStickyAtc();
    initProductShare();
    initSearch();
    initHeroSliders();
    initCollectionFilters();
  });
  document.addEventListener('shopify:section:load', (event) => {
    initHeroSliders(event.target);
    initProductGallery();
    initProductZoom();
    initStickyAtc();
    initProductShare();
  });
})();
